'use client';

import { createContext, ReactNode, useContext, useState } from 'react';
import { InformationProps } from 'ui/components/base/information/types';

export type Notification = {
	id: string;
	type: InformationProps['type'];
	message: string;
};

export const NotificationsContext = createContext<{
	notifications: Record<string, Notification>;
	showNotification: (notification: Notification) => void;
}>({
	notifications: {},
	showNotification: () => {},
});

export const NotificationsProvider = ({ children }: { children: ReactNode }) => {
	const [notifications, setNotifications] = useState<Record<string, Notification>>({});

	function showNotification(notification: Notification) {
		setNotifications((prev) => ({ ...prev, [notification.id]: notification }));

		setTimeout(() => {
			setNotifications((prev) => {
				const { [notification.id]: _, ...rest } = prev;
				return rest;
			});
		}, 3000);
	}

	return (
		<NotificationsContext.Provider value={{ notifications, showNotification }}>
			{children}
		</NotificationsContext.Provider>
	);
};

export const useNotifications = () => {
	return useContext(NotificationsContext);
};
